/* Gerenic library javascript file dealing with points */

class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }

  get x() {
    return this.xValue;
  }

  set x(value) {
    this.xValue = value;
  }

  get y() {
    return this.yValue;
  }

  set y(value) {
    this.yValue = value;
  }

  // Compute the difference from another point (returns a point)
  differenceFromPoint(pt) {
    return new Point(this.x - pt.x, this.y - pt.y);
  }
}

export default Point;
